import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-cust-grps',
  templateUrl: './cust-grps.component.html',
  styleUrls: ['./cust-grps.component.css']
})
export class CustGrpsComponent implements OnInit {
    public setting?: Setting;

    public itemsListCustomerGroups: Item[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(4019))[0];
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_custgrps_grid')
                .setLoadDataFunction({
                    method: 4018,
                    parameters: this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    show_setting: string;
}
